import { Component } from '@angular/core';

import { RestartDeviceBaseDirective } from './restart-device.base.directive';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ml-mdm-restart-device',
  templateUrl: './restart-device.component.html',
  imports: [NgClass],
})
export class RestartDeviceComponent extends RestartDeviceBaseDirective {}
